
import Button from '@/ui-kit/components/button';
import { ButtonFillType, ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ModalService from '@/ui-kit/components/modal/ModalService';
import MarketDataShareModal from '@/components/page-specific/market-data/share/modal/index';
import ToastService from '@/components/toast/toast-service';
import { ToastMessage } from '@/ui-kit/components/toast/enums';

export default {
  name: 'ShareChartButton',
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
      default: 'Share this search',
    },
  },
  data() {
    return {
      ButtonFillType,
      StyleColorSchemeType,
      ButtonProperty,
      ButtonPropsEventType,
    };
  },
  methods: {
    async onShare() {
      const shareSearchModal = await ModalService.open({
        component: MarketDataShareModal,
      });

      if (shareSearchModal) {
        ToastService.openPositive(ToastMessage.MarketDataShareSearchSuccess);
        this.$emit('shared');
      }
    },
  },
};
